import Icon from 'utility/icomoon';
import * as screens from '@core/layouts/components/menu/screens';
import paths from './paths';
import permissions from './permissions';

export default [
  {
    id: 'whatsapp',
    title: 'whatsapp.title',
    icon: <Icon size={20} icon="whatsapp" />,
    iconName: 'whatsapp',
    badge: 'primary',
    badgeText: 'common.comingSoon',
    permissions: permissions.whatsappScreen,
    navLink: paths.whatsapp,
    screenId: screens.WHATSAPP
  }
];
